import {Fragment, useEffect, useState} from 'react'
import './ItemChat.css'
import {Box, Text, Img, Flex, Collapse, Image} from '@chakra-ui/react'
import {defaultAvatarUrl} from '@utils/Const'
import TopArrowIcon from '@assets/svgs/learn/arrow_top_1.svg'
import StarIcon from '@assets/svgs/learn/star.svg'
import RightArrowIcon from '@assets/svgs/learn/arrow-right_1.svg'

const ItemSuggestionTable = ({message}: {message: any}) => {
  const {band, improvement, text, improvement_title} = message?.message || {}
  const [dataImprovement, setDataImprovement] = useState<any[]>([])

  useEffect(() => {
    const updateImprovement = improvement?.map((e: any, i: number) => ({
      ...e,
      active: false,
      index: i,
    }))
    setDataImprovement(updateImprovement)
  }, [])

  const handleShowDetail = (item: any) => {
    const updateImprovement = dataImprovement?.map((e, i) => ({
      ...e,
      active: i === item.index ? !e.active : false,
    }))
    setDataImprovement(updateImprovement)
  }

  return (
    <Box className={`chat-message item-suggestion-table`}>
      <Img src={defaultAvatarUrl} alt="Avatar" className="avatar" />
      <Box className="wrap-box" borderWidth={1} borderColor={'#01ACFF'}>
        <Flex
          flexDirection={{base: 'column', md: 'row'}}
          justifyContent={'space-between'}
          alignItems={{base: 'flex-start', md: 'center'}}
          gap={{base: 2, md: 0}}>
          <Flex flexDirection={'row'} alignItems={'center'}>
            <Text fontWeight={'600'} fontSize={{base: 16, md: 20}}>
              Câu đề xuất
            </Text>
            <Image src={StarIcon} />
          </Flex>
          <Text
            borderRadius={'11px 11px 0px 0px'}
            bgColor={'#40A9FF'}
            color={'#E6F7FF'}
            mr={{base: 0, md: '24px'}}
            py={'4px'}
            px={'8px'}
            fontWeight={'600'}
            fontSize={{base: 16, md: 20}}>
            {band}
          </Text>
        </Flex>

        <Text
          bgColor={'#E6F7FF'}
          p={{base: '12px', md: '16px'}}
          borderRadius={'19px'}
          fontSize={{base: 14, md: 16}}>
          {text}
        </Text>

        <Flex flexDirection={'row'} mt={'14px'}>
          <Text fontWeight={'600'} fontSize={{base: 16, md: 20}}>
            {improvement_title}
          </Text>
          <Img src={TopArrowIcon} />
        </Flex>

        {dataImprovement?.map((item, i: number) => (
          <Fragment key={i}>
            <Flex
              maxW={'100%'}
              cursor={'pointer'}
              onClick={() => handleShowDetail(item)}
              fontWeight={'500'}
              fontSize={{base: 14, md: 16}}
              flexDirection={'row'}
              flexWrap={'wrap'}
              bgColor={item.active ? '#FFFFFF' : '#F5F5F5'}
              p={{base: '12px', md: '8px'}}
              borderRadius={'16px'}
              mt={i > 0 ? '10px' : 0}
              gap={{base: 2, md: 0}}>
              <Text>{item.original}</Text>
              <Flex
                alignItems="center"
                justifyContent={{base: 'flex-start', md: 'flex-start'}}>
                <Img mx={'8px'} src={RightArrowIcon} alignSelf={'center'} />
                <Text>{item.suggestion}</Text>
              </Flex>
              {!item.active && (
                <Text
                  ml={{base: 0, md: '20px'}}
                  textAlign={{base: 'left', md: 'left'}}
                  fontWeight={'600'}
                  fontSize={{base: 14, md: 16}}
                  color={'#1890FF'}>
                  CHI TIẾT
                </Text>
              )}
            </Flex>
            <Collapse in={item.active} animateOpacity>
              <Text
                p={'16px'}
                borderRadius={'19px'}
                fontWeight={'400'}
                fontSize={{base: 12, md: 14}}
                color={'rgba(0, 0, 0, 0.45)'}>
                {item.detail}
              </Text>
            </Collapse>
          </Fragment>
        ))}
      </Box>
    </Box>
  )
}

export default ItemSuggestionTable
